export const NDA_TEMPLATE_URL = "https://assets-raw.jny.io/nda-signatures/Journey_NDA_Template_Jan_18_2023.pdf";